export const detectFlexDirection = (
  element: Element,
): "horizontal" | "vertical" => {
  if (!element.ownerDocument?.defaultView) {
    return "horizontal";
  }

  const styles = element.ownerDocument.defaultView.getComputedStyle(element);
  const display = styles.display;
  const flexDirection = styles.flexDirection;

  if (display !== "flex" && display !== "inline-flex") {
    return "horizontal";
  }

  if (flexDirection === "row" || flexDirection === "row-reverse") {
    return "vertical";
  }

  return "horizontal";
};
